import { AlertTriangle } from 'lucide-react';
import { looksLikeGstin } from '@/lib/tax';

/**
 * A nudge, not a block: a document that charges GST should carry our GSTIN.
 * Shown while tax is being charged and neither the document's Tax ID nor the
 * organisation's looks like a GSTIN.
 */
export function GstinWarning({ taxRate, docTaxId, orgTaxId }: { taxRate: number; docTaxId?: string | null; orgTaxId?: string | null }) {
  if (!(Number(taxRate) > 0) || looksLikeGstin(docTaxId) || looksLikeGstin(orgTaxId)) return null;
  return (
    <div className="flex gap-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900 dark:border-amber-900 dark:bg-amber-950 dark:text-amber-200">
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
      <span>No GSTIN on file. A document that charges GST must show your GSTIN — add it under Settings → Documents (or in Tax ID above) before sending this to the client.</span>
    </div>
  );
}
